import { render, staticRenderFns } from "./All-Root.vue?vue&type=template&id=05395fb0&"
import script from "./All-Root.vue?vue&type=script&lang=js&"
export * from "./All-Root.vue?vue&type=script&lang=js&"
import style0 from "./All-Root.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports